import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export default function VulneracionReclutamiento({ 
	apiService, token, register, setValue, watch, user, errors = {}, setCargando
}) {
	const [reclutafactorriesgo, setReclutafactorriesgo] = useState([]);
	const [reclutamodocaptacion, setReclutamodocaptacion] = useState([]);
	const [reclutatipousoutilizacion, setReclutatipousoutilizacion] = useState([]);
	const [reclutagrupoarmado, setReclutagrupoarmado] = useState([]);
	const [reclutapresenciaamenaza, setReclutapresenciaamenaza] = useState([]);
	const [reclutanivelriesgo, setReclutanivelriesgo] = useState([]);
	const [reclutavinculacionalerta, setReclutavinculacionalerta] = useState([]);
	const [reclutasituaciondesplazamiento, setReclutasituaciondesplazamiento] = useState([]);
	const [reclutamedidaproteccion, setReclutamedidaproteccion] = useState([]);
	const [reclutaestadomedidafiscalia, setReclutaestadomedidafiscalia] = useState([]);
	const [entidadrelacionddhh, setEntidadrelacionddhh] = useState([]);
	const ObtenerDatosSelects = async () => {
		let url = `/ddhh/vulneraciones/obtenerdatosselectsreclutamiento`;
		try {
			setCargando(true);
			const response = await apiService.get(url, token);
			const result = await response.data;
			setReclutafactorriesgo(result.Reclutafactorriesgo || []);
			setReclutamodocaptacion(result.Reclutamodocaptacion || []);
			setReclutatipousoutilizacion(result.Reclutatipousoutilizacion || []);
			setReclutagrupoarmado(result.Reclutagrupoarmado || []);
			setReclutapresenciaamenaza(result.Reclutapresenciaamenaza || []);
			setReclutanivelriesgo(result.Reclutanivelriesgo || []);
			setReclutavinculacionalerta(result.Reclutavinculacionalerta || []);
			setReclutasituaciondesplazamiento(result.Reclutasituaciondesplazamiento || []);
			setReclutamedidaproteccion(result.Reclutamedidaproteccion || []);
			setReclutaestadomedidafiscalia(result.Reclutaestadomedidafiscalia || []);
			setEntidadrelacionddhh(result.Entidadrelacionddhh || []);
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setCargando(false);
		}
	}
	useEffect(() => {
		setValue('datosVulneracion.intIdusr', user);
	}, [setValue, user]);
	useEffect(() => {
		ObtenerDatosSelects();
	}, []);
	const factorriesgoSeleccionado = watch('datosVulneracion.intIdfactorriesgo');
	const modocaptacionSeleccionado = watch('datosVulneracion.intIdmodocaptacion');
	const tipousoSeleccionado = watch('datosVulneracion.intIdtipouso');
	const grupoarmadoSeleccionado = watch('datosVulneracion.intIdgrupoarmado');
	const presenciaamenazasSeleccionada = watch('datosVulneracion.intIdpresenciaamenazas');
	const nivelriesgoSeleccionado = watch('datosVulneracion.intIdnivelriesgo');
	const vinculacionalertaSeleccionada = watch('datosVulneracion.intIdvinculacionalerta');
	const situaciondesplazamientoSeleccionada = watch('datosVulneracion.intIdsituaciondesplazamiento');
	const quienremitecasoSeleccionado = watch('datosVulneracion.intQuienremitecaso');
	const rutaactivadaSeleccionada = watch('datosVulneracion.intRutaactivada');
	const medidaproteccionSeleccionada = watch('datosVulneracion.intIdmedidaproteccion');
	const estadomedidaSeleccionado = watch('datosVulneracion.intIdestadomedida');
	useEffect(() => {
		const selectValues = [
			['datosVulneracion.intIdfactorriesgo', factorriesgoSeleccionado, reclutafactorriesgo],
			['datosVulneracion.intIdmodocaptacion', modocaptacionSeleccionado, reclutamodocaptacion],
			['datosVulneracion.intIdtipouso', tipousoSeleccionado, reclutatipousoutilizacion],
			['datosVulneracion.intIdgrupoarmado', grupoarmadoSeleccionado, reclutagrupoarmado],
			['datosVulneracion.intIdpresenciaamenazas', presenciaamenazasSeleccionada, reclutapresenciaamenaza],
			['datosVulneracion.intIdnivelriesgo', nivelriesgoSeleccionado, reclutanivelriesgo],
			['datosVulneracion.intIdvinculacionalerta', vinculacionalertaSeleccionada, reclutavinculacionalerta],
			['datosVulneracion.intIdsituaciondesplazamiento', situaciondesplazamientoSeleccionada, reclutasituaciondesplazamiento],
			['datosVulneracion.intQuienremitecaso', quienremitecasoSeleccionado, entidadrelacionddhh],
			['datosVulneracion.intRutaactivada', rutaactivadaSeleccionada, entidadrelacionddhh],
			['datosVulneracion.intIdmedidaproteccion', medidaproteccionSeleccionada, reclutamedidaproteccion],
			['datosVulneracion.intIdestadomedida', estadomedidaSeleccionado, reclutaestadomedidafiscalia],
		];

		selectValues.forEach(([field, selectedValue, options]) => {
			if (options.length === 0 || selectedValue === '' || selectedValue == null) {
				return;
			}

			const value = typeof selectedValue === 'object'
				? (selectedValue.id ?? selectedValue.value ?? '')
				: selectedValue;
			if (value !== '') {
				setValue(field, String(value), {
					shouldValidate: true,
					shouldDirty: false,
				});
			}
		});
	}, [
		setValue,
		factorriesgoSeleccionado,
		modocaptacionSeleccionado,
		tipousoSeleccionado,
		grupoarmadoSeleccionado,
		presenciaamenazasSeleccionada,
		nivelriesgoSeleccionado,
		vinculacionalertaSeleccionada,
		situaciondesplazamientoSeleccionada,
		quienremitecasoSeleccionado,
		rutaactivadaSeleccionada,
		medidaproteccionSeleccionada,
		estadomedidaSeleccionado,
		reclutafactorriesgo,
		reclutamodocaptacion,
		reclutatipousoutilizacion,
		reclutagrupoarmado,
		reclutapresenciaamenaza,
		reclutanivelriesgo,
		reclutavinculacionalerta,
		reclutasituaciondesplazamiento,
		entidadrelacionddhh,
		reclutamedidaproteccion,
		reclutaestadomedidafiscalia,
	]);
	return (
		<div className="card">
			<div className="card-header">
				<div className="col-md-12">
					<h6 className="text-primary font-weight-bold mb-3">Datos de la Vulneracion Reclutamiento</h6>
				</div>
			</div>
			<div className="card-body">
				<div className="row">
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strTrazabilidadrutaatencion">Trazabilidad ruta de atencion</label>
							<input
								type="text"
								maxLength={250}
								id="datosVulneracion.strTrazabilidadrutaatencion"
								className="form-control"
								{...register('datosVulneracion.strTrazabilidadrutaatencion' , { required: true })}
							/>
							{errors.datosVulneracion?.strTrazabilidadrutaatencion && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdfactorriesgo">Factores de Riesgo Espec&iacute;ficos</label>
							<select id="datosVulneracion.intIdfactorriesgo" className="form-control" {...register('datosVulneracion.intIdfactorriesgo' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {reclutafactorriesgo.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdfactorriesgo && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdmodocaptacion">Entorno / Modo de Captaci&oacute;n</label>
							<select id="datosVulneracion.intIdmodocaptacion" className="form-control" {...register('datosVulneracion.intIdmodocaptacion' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {reclutamodocaptacion.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdmodocaptacion && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdtipouso">Tipo de Uso o Utilizaci&oacute;n</label>
							<select id="datosVulneracion.intIdtipouso" className="form-control" {...register('datosVulneracion.intIdtipouso' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {reclutatipousoutilizacion.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdtipouso && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdgrupoarmado">Grupo Armado / Actor Delincuencial Responsable</label>
							<select id="datosVulneracion.intIdgrupoarmado" className="form-control" {...register('datosVulneracion.intIdgrupoarmado' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {reclutagrupoarmado.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdgrupoarmado && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strOtrogrupoarmado">Si la respuesta anterior fue, otro. ¿Cu&aacute;l?</label>
							<input
								type="text"
								maxLength={120}
								id="datosVulneracion.strOtrogrupoarmado"
								className="form-control"
								{...register('datosVulneracion.strOtrogrupoarmado' , { required: true })}
							/>
							{errors.datosVulneracion?.strOtrogrupoarmado && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdpresenciaamenazas">Presencia de Amenazas Directas a la Familia</label>
							<select id="datosVulneracion.intIdpresenciaamenazas" className="form-control" {...register('datosVulneracion.intIdpresenciaamenazas' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {reclutapresenciaamenaza.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdpresenciaamenazas && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdnivelriesgo">Nivel de Riesgo / Alerta de Reclutamiento</label>
							<select id="datosVulneracion.intIdnivelriesgo" className="form-control" {...register('datosVulneracion.intIdnivelriesgo' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {reclutanivelriesgo.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdnivelriesgo && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdvinculacionalerta">Vinculaci&oacute;n a Alerta Temprana (Defensoría del Pueblo)</label>
							<select id="datosVulneracion.intIdvinculacionalerta" className="form-control" {...register('datosVulneracion.intIdvinculacionalerta' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {reclutavinculacionalerta.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdvinculacionalerta && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdsituaciondesplazamiento">Situaci&oacute;n de Desplazamiento Forzado </label>
							<select id="datosVulneracion.intIdsituaciondesplazamiento" className="form-control" {...register('datosVulneracion.intIdsituaciondesplazamiento' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {reclutasituaciondesplazamiento.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdsituaciondesplazamiento && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intQuienremitecaso">Quien remite el caso</label>
							<select id="datosVulneracion.intQuienremitecaso" className="form-control" {...register('datosVulneracion.intQuienremitecaso' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {entidadrelacionddhh.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intQuienremitecaso && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intRutaactivada">Ruta activada</label>
							<select id="datosVulneracion.intRutaactivada" className="form-control" {...register('datosVulneracion.intRutaactivada' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {entidadrelacionddhh.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intRutaactivada && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdmedidaproteccion">Medida de Protecci&oacute;n Activada</label>
							<select id="datosVulneracion.intIdmedidaproteccion" className="form-control" {...register('datosVulneracion.intIdmedidaproteccion' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {reclutamedidaproteccion.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdmedidaproteccion && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdestadomedida">Estado de Notificaci&oacute;n / Denuncia a Fiscal&iacute;a o Polic&iacute;a</label>
							<select id="datosVulneracion.intIdestadomedida" className="form-control" {...register('datosVulneracion.intIdestadomedida' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {reclutaestadomedidafiscalia.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdestadomedida && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strObservaciones">Observaciones</label>
							<textarea
								id="datosVulneracion.strObservaciones"
								rows="3"
								className="form-control"
								{...register('datosVulneracion.strObservaciones' , { required: true })}
							/>
							{errors.datosVulneracion?.strObservaciones && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
				</div>

				<input type="hidden" {...register('datosVulneracion.intIdusr', { valueAsNumber: true })} />
			</div>
		</div>
	);
}

VulneracionReclutamiento.propTypes = {
	errors: PropTypes.object,
	personas: PropTypes.array,
	register: PropTypes.func.isRequired,
	setValue: PropTypes.func.isRequired,
	watch: PropTypes.func.isRequired,
	user: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
